import { render } from "./dataScreenList.vue?vue&type=template&id=a2f4403a&scoped=true"
import script from "./dataScreenList.vue?vue&type=script&lang=js"
export * from "./dataScreenList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f4403a"]])

export default __exports__